<header class="card-layout-content-header">
  <div *ngIf="noLogo === false" class="card-layout-content-header__logo">
    <img
      src="../assets/images/cardLayoutHeaderLogo.png"
      srcset="
        ../assets/images/cardLayoutHeaderLogo.png,
        ../assets/images/cardLayoutHeaderLogo@2x.png 2x,
        ../assets/images/cardLayoutHeaderLogo@3x.png 3x
      "
      [height]="logo.default.height"
      [width]="logo.default.width"
      [attr.alt]="brand"
      [attr.aria-label]="brand"
    />
  </div>
  <ng-content select="app-card-layout-content-image"></ng-content>
  <div class="card-layout-content-header__title"><ng-content select="app-card-layout-content-title"></ng-content></div>
  <ng-content select="app-card-layout-content-subtitle"></ng-content>
  <div class="card-layout-content-header__description">
    <ng-content select="app-card-layout-content-description"></ng-content>
  </div>
</header>
